
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from 'react-hook-form';

interface EthnicityFieldProps {
  form: UseFormReturn<any>;
}

const EthnicityField: React.FC<EthnicityFieldProps> = ({ form }) => {
  const ethnicityOptions = [
    "Asian", 
    "Black/African", 
    "Caucasian/White", 
    "Hispanic/Latinx", 
    "Middle Eastern", 
    "Native American/Indigenous", 
    "Pacific Islander",
    "Mixed/Multiple ethnic groups",
    "Other"
  ];

  return (
    <FormField
      control={form.control}
      name="ethnicity"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Ethnicity</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select your ethnicity" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {ethnicityOptions.map((option) => (
                <SelectItem key={option} value={option}>
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default EthnicityField;
